/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["#asset-content[_ngcontent-%COMP%]{border:none;height:700px;display:block;overflow:hidden;width:1px;min-width:100%}"];
export { styles as styles };
